import React from "react";
import MarkdownRenderer from "../common/MarkdownRenderer";
import { getAbout } from "../../lib/loadContent";
import useStore from "../../lib/store";
import PFP from "../../assets/profile.webp";

const About = () => {
  const about = getAbout();
  const openFloatingWindow = useStore((s) => s.openFloatingWindow);
  const ASCII = `
 █████╗ ██████╗  ██████╗ ██╗   ██╗████████╗
██╔══██╗██╔══██╗██╔═══██╗██║   ██║╚══██╔══╝
███████║██████╔╝██║   ██║██║   ██║   ██║   
██╔══██║██╔══██╗██║   ██║██║   ██║   ██║   
██║  ██║██████╔╝╚██████╔╝╚██████╔╝   ██║   
╚═╝  ╚═╝╚═════╝  ╚═════╝  ╚═════╝    ╚═╝   `;

  return (
    <div className="page about">
      <div className="about-header">
        <img
          src={PFP}
          alt="Portrait"
          className="about-portrait"
          title="Click to preview"
          onClick={() =>
            openFloatingWindow({
              title: "About",
              content: (
                <img src={PFP} className="floating-img" alt="Portrait" />
              ),
            })
          }
        />
        <div>
          <p className="ascii-logo">{ASCII}</p>
          <p className="page-path">~/portfolio/about.md</p>
        </div>
      </div>
      <MarkdownRenderer>{about.content}</MarkdownRenderer>
    </div>
  );
};

export default About;
